module.exports = __webpack_public_path__ + "static/lemonade-4b92f17dcf3d90ec2035535f94ae7730.svg";